<template>
  <div class="content" v-if="route.name == 'Beranda'">
    <Beranda/>
  </div>
  <div class="content" v-if="route.name == 'Login'">
    <Login/>
  </div>
  <div class="content" v-if="route.name == 'KontakKami'">
    <KontakKami/>
  </div>
  <div class="content" v-if="route.name == 'DaftarProgramBudgeting'">
    <DaftarProgramBudgeting/>
  </div>
  <div class="content" v-if="route.name == 'DaftarFinance'">
    <DaftarFinance/>
  </div>
  <div class="content" v-if="route.name == 'DaftarMonev'">
    <DaftarMonev/>
  </div>
  <div class="content" v-if="route.name == 'DaftarKegiatan'">
    <DaftarKegiatan/>
  </div>
  <div class="content" v-if="route.name == 'DaftarBerita'">
    <DaftarBerita/>
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbum'">
    <DaftarAlbum/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleri'">
    <DaftarGaleri/>
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbumDokumen'">
    <DaftarAlbumDokumen/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleriDokumen'">
    <DaftarGaleriDokumen/>
  </div>
  <div class="content" v-if="route.name == 'Dashboard'">
    <Dashboard/>
  </div>
  <div class="content" v-if="route.name == 'Slider'">
    <Slider/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSlider'">
    <ProsesSlider/>
  </div>
  <div class="content" v-if="route.name == 'Kategori'">
    <Kategori/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKategori'">
    <ProsesKategori/>
  </div>
  <div class="content" v-if="route.name == 'SubKategori'">
    <SubKategori/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSubKategori'">
    <ProsesSubKategori/>
  </div>
  <div class="content" v-if="route.name == 'UnitKategori'">
    <UnitKategori/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUnitKategori'">
    <ProsesUnitKategori/>
  </div>
  <div class="content" v-if="route.name == 'InfoBeranda'">
    <InfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'ProsesInfoBeranda'">
    <ProsesInfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'Konten'">
    <Konten/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKonten'">
    <ProsesKonten/>
  </div>
  <div class="content" v-if="route.name == 'User'">
    <User/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUser'">
    <ProsesUser/>
  </div>
  <div class="content" v-if="route.name == 'Monev'">
    <Monev/>
  </div>
  <div class="content" v-if="route.name == 'IPP'">
    <IPP/>
  </div>
  <div class="content" v-if="route.name == 'GAP'">
    <GAP/>
  </div>
  <div class="content" v-if="route.name == 'CEMP'">
    <CEMP/>
  </div>
  <div class="content" v-if="route.name == 'RKLRPL'">
    <RKLRPL/>
  </div>
  <div class="content" v-if="route.name == 'Sampel'">
    <Sampel/>
  </div>
  <div class="content" v-if="route.name == 'Regulasi'">
    <Regulasi/>
  </div>
  <div class="content" v-if="route.name == 'ProsesRegulasi'">
    <ProsesRegulasi/>
  </div>
  <div class="content" v-if="route.name == 'DaftarRegulasi'">
    <DaftarRegulasi/>
  </div>
  <div class="content" v-if="route.name == 'KategoriData'">
    <KategoriData/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKategoriData'">
    <ProsesKategoriData/>
  </div>
  <div class="content" v-if="route.name == 'LayerPeta'">
    <LayerPeta/>
  </div>
  <div class="content" v-if="route.name == 'ProsesLayerPeta'">
    <ProsesLayerPeta/>
  </div>
  <div class="content" v-if="route.name == 'Berita'">
    <Berita/>
  </div>
  <div class="content" v-if="route.name == 'ProsesBerita'">
    <ProsesBerita/>
  </div>
  <div class="content" v-if="route.name == 'Galeri'">
    <Galeri/>
  </div>
  <div class="content" v-if="route.name == 'ProsesGaleri'">
    <ProsesGaleri/>
  </div>
  <div class="content" v-if="route.name == 'DetailGaleri'">
    <DetailGaleri/>
  </div>
  <div class="content" v-if="route.name == 'Dokumen'">
    <Dokumen/>
  </div>
  <div class="content" v-if="route.name == 'ProsesDokumen'">
    <ProsesDokumen/>
  </div>
  <div class="content" v-if="route.name == 'DetailDokumen'">
    <DetailDokumen/>
  </div>
  <div class="content" v-if="route.name == 'GIS'">
    <GIS/>
  </div>
  <div class="content" v-if="route.name == 'DaftarKonten'">
    <DaftarKonten/>
  </div>
  <div class="content" v-if="route.name == 'ImportExcel'">
    <ImportExcel/>
  </div>
</template>

<script>
import Beranda from './components/views/Publik/Beranda.vue';
import Login from './components/views/Publik/Login.vue';
import KontakKami from './components/views/Publik/KontakKami.vue';
import DaftarProgramBudgeting from './components/views/Publik/DaftarProgramBudgeting.vue';
import DaftarFinance from './components/views/Publik/DaftarFinance.vue';
import DaftarMonev from './components/views/Publik/DaftarMonev.vue';
import Dashboard from './components/views/Dashboard/Dashboard.vue';
import Slider from './components/views/Backoffice/Slider/Slider.vue';
import ProsesSlider from './components/views/Backoffice/Slider/ProsesSlider.vue';
import Kategori from './components/views/Backoffice/Kategori/Kategori.vue';
import ProsesKategori from './components/views/Backoffice/Kategori/ProsesKategori.vue';
import SubKategori from './components/views/Backoffice/SubKategori/SubKategori.vue';
import ProsesSubKategori from './components/views/Backoffice/SubKategori/ProsesSubKategori.vue';
import UnitKategori from './components/views/Backoffice/UnitKategori/UnitKategori.vue';
import ProsesUnitKategori from './components/views/Backoffice/UnitKategori/ProsesUnitKategori.vue';
import InfoBeranda from './components/views/Backoffice/InfoBeranda/InfoBeranda.vue';
import ProsesInfoBeranda from './components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue';
import Konten from './components/views/Backoffice/Konten/Konten.vue';
import ProsesKonten from './components/views/Backoffice/Konten/ProsesKonten.vue';
import User from './components/views/Backoffice/User/User.vue';
import ProsesUser from './components/views/Backoffice/User/ProsesUser.vue';
import Monev from './components/views/Backoffice/Monev/Monev.vue';
import IPP from './components/views/Backoffice/IPP/IPP.vue';
import ImportExcel from './components/views/ImportExcel/ImportExcel.vue';
import GAP from './components/views/Backoffice/GAP/GAP.vue';
import CEMP from './components/views/Backoffice/CEMP/CEMP.vue';
import RKLRPL from './components/views/Backoffice/RKLRPL/RKLRPL.vue';
import Sampel from './components/views/Backoffice/Sampel/Sampel.vue';
import Regulasi from './components/views/Backoffice/Regulasi/Regulasi.vue';
import ProsesRegulasi from './components/views/Backoffice/Regulasi/ProsesRegulasi.vue';
import DaftarRegulasi from './components/views/Publik/DaftarRegulasi.vue';
import KategoriData from './components/views/Backoffice/KategoriData/KategoriData.vue';
import ProsesKategoriData from './components/views/Backoffice/KategoriData/ProsesKategoriData.vue';
import LayerPeta from './components/views/Backoffice/LayerPeta/LayerPeta.vue';
import ProsesLayerPeta from './components/views/Backoffice/LayerPeta/ProsesLayerPeta.vue';
import GIS from './components/views/Publik/GIS.vue';
import DaftarKonten from './components/views/Publik/DaftarKonten.vue';
import DaftarKegiatan from './components/views/Publik/DaftarKegiatan.vue';
import DaftarBerita from './components/views/Publik/DaftarBerita.vue';
import Berita from './components/views/Backoffice/Berita/Berita.vue';
import ProsesBerita from './components/views/Backoffice/Berita/ProsesBerita.vue';
import DaftarAlbum from './components/views/Publik/DaftarAlbum.vue';
import DaftarGaleri from './components/views/Publik/DaftarGaleri.vue';
import Galeri from './components/views/Backoffice/Galeri/Galeri.vue';
import ProsesGaleri from './components/views/Backoffice/Galeri/ProsesGaleri.vue';
import DetailGaleri from './components/views/Backoffice/Galeri/DetailGaleri.vue';
import Dokumen from './components/views/Backoffice/Dokumen/Dokumen.vue';
import ProsesDokumen from './components/views/Backoffice/Dokumen/ProsesDokumen.vue';
import DetailDokumen from './components/views/Backoffice/Dokumen/DetailDokumen.vue';
import DaftarAlbumDokumen from './components/views/Publik/DaftarAlbumDokumen.vue';
import DaftarGaleriDokumen from './components/views/Publik/DaftarGaleriDokumen.vue';

import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  components: {
    Beranda,Login,KontakKami,Dashboard,GIS,DaftarKonten,DaftarProgramBudgeting
    ,DaftarFinance,DaftarMonev
    ,Slider,ProsesSlider,InfoBeranda,ProsesInfoBeranda,Konten,ProsesKonten
    ,User,ProsesUser,KategoriData,ProsesKategoriData,Monev,CEMP,Sampel
    ,Regulasi,ProsesRegulasi,DaftarRegulasi,Kategori,ProsesKategori
    ,SubKategori,ProsesSubKategori,UnitKategori,ProsesUnitKategori
    ,LayerPeta,ProsesLayerPeta,RKLRPL,IPP,GAP,ImportExcel
    ,DaftarKegiatan,Berita,ProsesBerita,DaftarBerita,Galeri,ProsesGaleri,DetailGaleri
    ,DaftarAlbum,DaftarGaleri,Dokumen,ProsesDokumen,DetailDokumen
    ,DaftarAlbumDokumen,DaftarGaleriDokumen
  },
  mounted() {
    document.title = "PPMS";
  },
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  }
}
</script>

<style></style>
